import React from 'react';
import PropTypes from 'prop-types';
import { getNetworkLogoUrl } from 'helpers/ContentHelper';

const NetworkImage = ({ network, theme }) => {
  if (!network) return null;
  return <img className={theme.image} alt={network} src={getNetworkLogoUrl(network)} />;
};

NetworkImage.propTypes = {
  theme: PropTypes.shape({ image: PropTypes.string }).isRequired,
  network: PropTypes.string.isRequired,
};

export default NetworkImage;
